module.exports = __webpack_public_path__ + "img/light-2.217b25da.svg";